import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import { getMisc } from "../../../../localstorage-service";

class AssessmentInstructions extends Component {
  render() {
    return (
      <Aux>
        <p dangerouslySetInnerHTML={{ __html: getMisc("assessmentinstructions") }} />
        <hr />
        <center>
          <button className="btn btn-default" onClick={this.props.startAssessmentClicked}>
            {getMisc("clickheretostartassessment")}
          </button>
        </center>
      </Aux>
    );
  }
}

export default AssessmentInstructions;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoMain/AssessmentInstructions.js